module.exports = __webpack_public_path__ + "img/billing_patient_bill.508188d5.svg";